import { PaginationModel } from '@/utils/pagination';

export enum ErrorCode {
  ValidationError = 'validation_error',
  EmailInUsedError = 'email_already_in_used',
  PhoneInUsedError = 'phone_number_already_in_used',
}

export interface FieldError {
  context: string;
  field: string;
  code: string;
  message?: string;
}

export interface ErrorResponse {
  message: string;
  code: ErrorCode;
  errors: FieldError[];
  error?: string;
}

export interface PaginatedResponse {
  Response: any;
  pagination: PaginationModel;
}
